import { useNavigate } from "react-router-dom";

import {
  NotFoundActionButton,
  NotFoundCode,
  NotFoundContainer,
  NotFoundDescription,
  NotFoundTitle,
} from "app/router/index.style";

function NotFoundPage() {
  const navigate = useNavigate();
  const hasToken = localStorage.getItem("admintoken") !== null;

  return (
    <NotFoundContainer>
      <NotFoundCode>404</NotFoundCode>
      <NotFoundTitle>페이지를 찾을 수 없습니다.</NotFoundTitle>
      <NotFoundDescription>
        요청한 주소가 잘못되었거나 삭제된 페이지입니다.
      </NotFoundDescription>
      <NotFoundActionButton
        type="button"
        onClick={() => navigate(hasToken ? "/" : "/login")}
      >
        {hasToken ? "홈으로 돌아가기" : "로그인으로 돌아가기"}
      </NotFoundActionButton>
    </NotFoundContainer>
  );
}

export default NotFoundPage;
